module.exports = __webpack_public_path__ + "static/media/album.c79ba839.png";